import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleCheckmark.svg",
  "use": "CircleCheckmark.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleCheckmark.svg\"><path d=\"M32.01,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0208Zm13.4-35.4186a2.0012,2.0012,0,0,0-3.049.2777L29.5172,39.27l-5.8744-8.4112a2.0012,2.0012,0,0,0-3.049-.2777,2.0853,2.0853,0,0,0-.1712,2.67l6.6244,9.485a3.0141,3.0141,0,0,0,4.9407,0L45.5814,23.2717A2.0854,2.0854,0,0,0,45.41,20.6022Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol